// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3zINM","actions":"GroupTable_actions__2TLBl","deleteModalFooter":"GroupTable_deleteModalFooter__GEJee"};